import type { Catalog } from "../../en";
import { workflowsService } from "./workflows-service";

const WORKFLOWS_SERVICE_LOCK = workflowsService.addStepLock;


/** Filipino: the Add-step menu (P5-2). Included in `engage.workflows.addStep`. Keywords are comma-separated search words. */
export const workflowsAddStep: Catalog["engage"]["workflows"]["addStep"] = {
  searchLabel: "Magdagdag ng hakbang",
  searchPlaceholder: "Maghanap",
  results_one: "{{count}} resulta",
  results_other: "{{count}} resulta",
  sections: {
    replace: "Palitan ng",
    suggested: "Mungkahing susunod na hakbang",
    content: "Magdagdag ng content sa path",
    actions: "Mga aksyon",
    flow: "Daloy",
  },
  viewMore: "Tingnan pa ({{count}})",
  moreOf: "{{section}}: mas maraming hakbang",
  viewLess: "Tingnan nang kaunti",
  replaceNotice: "Hindi tatakbo ang mga hakbang pagkatapos ng {{step}}. Palitan ito, o ikonekta ang mga labasan nito sa ibang path.",
  replaced: "Pinalitan ang {{from}} ng {{to}}.",
  locks: {
    service: WORKFLOWS_SERVICE_LOCK,
    plan: "kailangan ang plan na {{plan}}",
    conversation: "Kailangan ng usapan, kaya hindi ito magagamit sa mga trigger na tumatakbo nang walang usapan.",
  },
  empty: {
    title: "Walang hakbang na tugma sa “{{query}}”",
    body: "Subukan ang ibang salita, gaya ng “tag”, “mensahe” o “maghintay”.",
    clear: "Burahin ang hinahanap",
  },
  presets: {
    close_conversation: "Isara ang usapan",
    resolve_conversation: "I-resolve ang usapan",
  },
  keywords: {
    ...workflowsService.keywords,
    send_webhook: "webhook, post, http, endpoint, ipaalam sa system",
    add_tags: "tag, label, ikategorya, lagyan",
    remove_tags: "alisin ang tag, tag, label, burahin",
    assign: "italaga, ipasa, koponan, team, may-ari",
    set_status: "estado, katayuan, bukas, sarado, resolved",
    add_note: "tala, nota, komento, internal",
    update_lead: "lead, yugto, crm, may-ari",
    notify_staff: "abisuhan, abiso, magpaalala, sabihan ang team",
    apply_sla: "sla, takdang oras, target ng sagot",
    set_priority: "prayoridad, apurahan, mataas",
    email_visitor: "email, liham, magpadala ng email",
    set_attribute: "katangian, attribute, itakda, i-save, custom field",
    run_workflow: "workflow, patakbuhin, tawagin, ibang workflow",
    http_request: "data connector, tumawag ng action, http, api, request, kumuha, lookup, endpoint",
    send_message: "mensahe, magpadala, sagot, sumulat",
    reply_buttons: "pindutan, buttons, mabilis na sagot, pagpipilian, menu",
    collect_data: "magtanong, tanong, form, detalye, impormasyon, kunin",
    let_assistant_answer: "katulong, assistant, ai, bot, sumagot, sagot",
    show_booking: "booking, iskedyul, appointment, pagpapareserba, kalendaryo",
    show_lead_form: "lead, kontak, form, kunin ang detalye",
    hand_to_person: "tao, ipasa, staff, kawani, handoff, ahente",
    expected_reply_time: "oras ng sagot, gaano katagal, inaasahang tugon",
    ask_rating: "rating, puna, feedback, bituin, survey",
    branch: "sangay, kondisyon, kung, hatiin, magpasya",
    apply_rules: "panuntunan, rules, kondisyon, maraming aksyon",
    wait: "maghintay, antala, ipagpaliban, oras, mamaya",
    wait_for_webhook: "hintayin, callback, panlabas na system, hook",
    go_to_path: "pumunta, path, magpatuloy, lumipat",
    end: "tapusin, wakas, hinto, tapos, lumabas",
    close_conversation: "isara, sarado, tapusin ang usapan, close",
    resolve_conversation: "resolve, naresolba, nalutas, tapos",
    collect_reply: "sagot, sagot ng bisita, malayang teksto, mag-type, hintayin ang sagot, magtanong",
    disable_reply: "i-lock, i-disable, bawal mag-type, chat box, harangin",
    enable_reply: "i-unlock, i-enable, payagang mag-type, chat box",
    snooze: "snooze, ipaalala, mamaya, ipagpaliban, antalahin",
    set_language: "wika, language, isalin, filipino, english",
    show_article: "artikulo, help article, knowledge, link, website, pahina, gabay, card",
    add_summary_note: "buod, ibuod, ai note, tala, internal note, recap",
  },
};
